export default "__VITE_ASSET__1034ae7e__$_?component__"